import React from "react";
import { useNavigate, useSearchParams, createSearchParams, URLSearchParamsInit } from "react-router-dom";

function useQueryParams() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // get query params
    const queryParams: Record<string, string> = React.useMemo(
        () => Object.fromEntries([...searchParams]),
        [searchParams],
    );

    // updates the query params
    function setQueryParams(queryObj: URLSearchParamsInit | undefined) {
        navigate({
            pathname: ".",
            search: `?${createSearchParams(queryObj)}`,
        });
    }

    return { queryParams, setQueryParams };
}

export default useQueryParams;
